import {
  createRootRouteWithContext,
  Outlet,
  useRouter,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { QueryClient } from "@tanstack/react-query";
import type { myStore } from "@/main";
import { useEffect } from "react";
import { AUTH_EVENTS, authEvents } from "@/utils/authEvents";
import { GlobalErrorModal } from "@/components/shared/GlobaErrorlModal";

interface MyRouterContext {
  queryClient: QueryClient;
  store: typeof myStore;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const router = useRouter();
  useEffect(() => {
    const handleSessionExpired = () => {
      // เมื่อได้รับสัญญาณ ให้ย้ายไปหน้า login ทันที
      router.navigate({
        to: "/login",
        search: {
          // ส่งหน้าที่อยู่ปัจจุบันไป เพื่อให้ login เสร็จแล้วกลับมาได้
          redirect: location.pathname,
        },
      });
    };

    authEvents.on(AUTH_EVENTS.SESSION_EXPIRED, handleSessionExpired);

    // อย่าลืม cleanup listener
    return () => {
      authEvents.off(AUTH_EVENTS.SESSION_EXPIRED, handleSessionExpired);
    };
  }, [router]);

  return (
    <>
      <Outlet />
      <TanStackRouterDevtools position="bottom-right" />
      <ReactQueryDevtools position="bottom" />
      <GlobalErrorModal />
    </>
  );
}
